import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { UserService } from 'src/app/service/user.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-profile',
  templateUrl: './create-profile.component.html',
  styleUrls: ['./create-profile.component.scss']
})
export class CreateProfileComponent implements OnInit {

  userID: any;
  showLoader: boolean = false;
  updating: boolean = false;
  user: any;

  editUser = new FormGroup({
    username: new FormControl(''),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),
      // Validators.pattern('^[a-zA-Z0-9-_]([.](?![.])|[a-zA-Z0-9-_])*([@](?![@])|[a-zA-Z])([.](?![.])|[a-zA-Z])*[a-zA-Z]$'),
    ]),
    displayName: new FormControl('', [
      Validators.required
    ]),
    mobile: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(private toastrService: ToastrService, public translate: TranslateService, private userService: UserService, public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    // this.user = {
    //   id: 1,
    //   username: "user1",
    //   type: "student",
    //   email: "user1@domain.com",
    //   displayName: "user1",
    //   mobile: "xxxxxxxxxxx",
    //   active: true,
    //   organization: "organization1",
    //   role: "role1"
    // };

    this.getUserByName(this.globals.currentUserInfo.username);

    // this.activatedRoute
    //   .queryParams
    //   .subscribe(params => {
    //     this.userID = params['userID'] || "";

    //     if (this.userID != "") {
    //       this.showLoader = true;
    //       // Get User
    //       this.getUserInfo();
    //     } else {
    //       console.log("no user");
    //       this.router.navigate(['/user']);
    //     }
    //   });
  }
  getUserByName(userName: string) {
    // this.usersSearch = this.data[0];
    // this.updateTable();
    this.userService.getUserByUsername(this.globals.currentUserInfo.username)
      .subscribe(
        data => {
          if (data) {
            this.editUser.controls.username.setValue(data.username);
            this.editUser.controls.email.setValue(data.email);

            this.editUser.controls.displayName.setValue(data.displayName);
            this.editUser.controls.mobile.setValue(data.mobile);

            // this.user.username= data.username,
            // this.user.email= data.email,
            // this.user.displayName= data.displayName,
            // this.user.mobile=data.mobile

          } else {
            this.router.navigate(['/home']);
            this.toastrService.warning(this.translate.instant("NOT_FOUND"));

          }
        },
        error => {
          this.router.navigate(['/home']);
          this.toastrService.warning(this.translate.instant("CAN_NOT_GET_USER"));
        },
      );

  }
  editUserChange() {

  }

  editUserSubmit() {

    if (this.editUser.valid) {

      // Update user info
      this.updateUser(this.globals.currentUserInfo.userid, this.editUser.controls.email.value,
        this.editUser.controls.displayName.value, this.editUser.controls.mobile.value);

    }
    else {
      this.editUser.markAllAsTouched();
      this.editUser.markAsDirty();
    }
  }

  getUserInfo() {

  }



  updateUser(userId: any, email: string, displayName: string, mobile: string) {
    // this.updating = true;
    this.userService.updateUserProfile(userId, email, displayName, mobile)
      .subscribe(
        data => {
          this.router.navigate(['/home']);
          this.toastrService.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
        },
        error => {
          this.router.navigate(['/home']);
          this.toastrService.warning(this.translate.instant("CAN_NOT_UPDATE"));
        },
      );

  }

}
